import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { queryKeys, type UserMembership } from '@vtak/shared';
import { workspaceClient } from '@/services/workspace-client';

/** Load the caller's memberships — drives the workspace gate. */
export function useMembershipQuery(): UseQueryResult<UserMembership[]> {
  return useQuery({
    queryKey: queryKeys.workspace.memberships,
    queryFn: () => workspaceClient.getMemberships(),
    staleTime: 30_000,
  });
}
